




import { Component, Vue } from "vue-property-decorator";
import Travel from "@/components/pages/modules/transitFacility/Travel/index.vue";

@Component({
  components: {
    Travel
  }
})

export default class TransitTravel extends Vue {}
